// e1c/src/contexts/AriaContext.js
import React, { createContext, useState, useMemo, useContext, useCallback } from 'react';
import logger from '../utils/logger'; // Ensure this path is correct

const AriaContext = createContext(null);

export const useAriaContext = () => {
    const context = useContext(AriaContext);
    if (context === null) {
        logger.error("useAriaContext must be used within an AriaContextProvider. Context is null.");
        throw new Error('useAriaContext must be used within an AriaContextProvider');
    }
    return context;
};

export const AriaContextProvider = ({ children }) => {
    const [deepPatientContext, setDeepPatientContextState] = useState(null);
    const [isContextLoading, setIsContextLoadingState] = useState(false);
    const [ariaMessages, setAriaMessagesState] = useState([]);

    const setDeepPatientContext = useCallback((context) => {
        setDeepPatientContextState(context);
    }, []);

    const setIsContextLoading = useCallback((isLoading) => {
        setIsContextLoadingState(isLoading);
    }, []);

    const setAriaMessages = useCallback((messages) => {
        setAriaMessagesState(messages);
    }, []);

    const clearDeepPatientContext = useCallback(() => {
        logger.info("ARIA Context: Clearing deep patient context.");
        setDeepPatientContextState(null);
    }, []);

    const value = useMemo(() => ({
        deepPatientContext,
        setDeepPatientContext,
        isContextLoading,
        setIsContextLoading,
        ariaMessages,
        setAriaMessages,
        clearDeepPatientContext,
    }), [
        deepPatientContext,
        isContextLoading,
        ariaMessages,
        setDeepPatientContext,
        setIsContextLoading,
        setAriaMessages,
        clearDeepPatientContext
    ]);

    return (
        <AriaContext.Provider value={value}>
            {children}
        </AriaContext.Provider>
    );
};